import useStockApiPing from '../../../../../gqlCommon/hooks/queries/useStockApiPing';
import Submit from '../../../presentational/actionButtons/customiseSubmit/Submit';
import React, { FunctionComponent } from 'react';
import { IButtonProps } from '../../../presentational/actionButtons/ActionButtons';

type ISubmitProps = IButtonProps & { disabled: boolean; loading?: boolean };
const SubmitWithStockPing: FunctionComponent<ISubmitProps> = ({ onClick, disabled }) => {
  const { isOrderPlacementDisabled } = useStockApiPing();

  return !isOrderPlacementDisabled && <Submit onClick={onClick} disabled={disabled} />;
};

export default SubmitWithStockPing;
